import React, { useState, useEffect, FC } from "react";
import { Table, Button, Input, Select, Checkbox, Tooltip } from "antd";
import { YHModal } from "@/components/YHModal";
import { useSaleOrderDetailModel } from "./saleOrderDetailModel";
import { ColumnsType } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { YhBut } from "@/components/YhButton";
import { IStockStatisticSonDetail, stockStatisticService } from "@/views/stock/statistic/stockStatisticService";
import { IDescription, DescriptionColorEnum } from "@/components/YhBox/Types";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useDictModel } from "@/views/base/dict/dictModel";



export const MaterialHistoryModel: FC<RouterParamType> = ({ id, mode }) => {
    const { materialHistoryModel: visible, materialHistoryRow, materialHistoryType, setMaterialHistoryModel, setMaterialHistoryRow, setMaterialHistoryType } = useSaleOrderDetailModel();
    const [dataSource, setDataSource] = useState<IStockStatisticSonDetail[]>([])
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const { getTreeNodeOne } = useDictModel();


    useEffect(() => {
        visible && getStockStatistic(materialHistoryType)
    }, [visible])
    const getStockStatistic = async (type: string) => {
        let params = {
            pageSize: 1000,
            pageNum: 1,
            tradeTypeCode: type,
            materialCode: materialHistoryRow.materialCode

        }
        let { retData } = await stockStatisticService.detailPage(params)
        const { records, ...pg } = retData;
        setDataSource(records)
    }
    const columns: ColumnsType<IStockStatisticSonDetail> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            // title: '单据编号',
            title: Locale["AppointmentDocNo"],
            width: 120,
            dataIndex: 'tradeCode',
        }, {
            // title: '单据日期',
            title: Locale["Creation Time"],
            width: 160,
            dataIndex: 'createTime',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '单据类型',
            title: Locale["Document  Type"],
            width: 160,
            dataIndex: 'tradeTypeCode',
            render: (text: any) => {
                if (text) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0]?.name : getTreeNodeOne(text)[0]?.nameEn as string
                } else {
                    return ""
                }
            }
        }, {
            // title: '单价',
            title: Locale["Unit Price"],
            width: 160,
            dataIndex: 'price',
        }, {
            // title: '数量',
            title: Locale["Qty"],
            width: 160,
            dataIndex: 'num',
        }, {
            // title: '折扣',
            title: Locale["Discount Rate"],
            width: 120,
            dataIndex: 'discountRate',
        }, {
            // title: '总价',
            title: Locale["Total"],
            width: 160,
            dataIndex: 'amount',
        },
    ]
    const onOK = async () => {
        onCancel()
    }
    const onCancel = () => {
        setMaterialHistoryModel(false);
        setMaterialHistoryRow({})
        setMaterialHistoryType("trade-type.purchase")
    };
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => getStockStatistic("trade-type.purchase")}
        >{Locale["Purchase History"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => getStockStatistic("trade-type.sale")}
        >{Locale["Sales History"]}</Button>
    </>
    const desc: IDescription[] = [
        {
            // label: "商品编码",
            label: Locale["Material Code"],
            value: materialHistoryRow.materialCode as string,
            color: DescriptionColorEnum.green
        },
        {
            // label: "商品名称",
            label: Locale["Material Name"],
            value: materialHistoryRow.materialName as string,
            color: DescriptionColorEnum.green
        },
        {
            // label: "商品名称",
            label: Locale["Material Name En"],
            value: materialHistoryRow.materialNameEn as string,
            color: DescriptionColorEnum.green
        }
    ]
    return (
        <YHModal
            visible={visible}
            onOk={onOK}
            onCancel={onCancel}
            // title="商品进销存明细"
            title={Locale["Purchase, Sales and Inventory Details"]}
            width={1200}
            bodyHeight={700}
            showFooter={true}
        >
            <YhBox title={action} descriptions={desc}>
                <Table
                    style={{ cursor: "pointer" }}
                    rowKey={record => record.id as string}
                    columns={columns}
                    dataSource={dataSource}
                    scroll={{ x: 'max-content', y: 550 }}
                    pagination={false}
                />

            </YhBox>
        </YHModal>
    )
} 